<template>
  <Card>
    <h1 slot="Title">Functional Area</h1>
    <div slot="MainContent">
      <p>
        <b>Structure and Critical Fields 131096QLOG</b>
      </p>
      <p>
        The Functional Area is a 16-digit field master data element. Depending on the appropriation (Main Account Code), Functional Area master data elements for Army appropriations may now contain the Army Program Element (APE), RDTE project number, Military Construction (MILCON) project number, Procurement Standard Study Number (SSN), Cost Type Code (CT), and Management Decision Package (MDEP). GFEBS controls the execution of funds based on appropriation and the Functional Areas using derivation rules.
      </p>
      <div class="ImageWrapper">
        <figure>
          <img :src="Image" alt="Graph">
        </figure>
      </div>

      <p>
        202011D20 A76VV <b><u>131096QLOG</u></b> 6100.2617 WBS, Internal Order or Cost Center 1000000067 021001
      </p>
    </div>
    <div slot="Notes">
      <p><strong>FUNCTIONAL AREA (cont.)</strong></p>
      <p><strong>Functional Area (Cont.)</strong></p>
      <p><strong>NOTE:&nbsp; Refer students to the Army Management Structure (Federated ERPs) Guide,</strong> <strong>Chapter 5 </strong>and <strong>Summary Sheet; Identify Master Data page #8.</strong></p>
      <p><strong>Structure and Critical Fields:</strong> The Functional Area is a 16-digit field master data element. Depending on the appropriation (Main Account Code), Functional Area master data elements for Army appropriations may now contain the Army Program Element (APE), RDTE project number, Military Construction (MILCON) project number, Procurement Standard Study Number (SSN), Cost Type Code (CT), and Management Decision Package (MDEP). GFEBS controls the execution of funds based on appropriation and the Functional Areas using derivation rules.</p>
      <p>Example:&nbsp; 131096- Army Program Element&nbsp; (APE)&nbsp; QLOG- Management Decision Package (MDEP)</p>
      <p><strong>Note: </strong><strong>Army Management Structure (Federated ERPs) Guide, A0-0725 thru AO-2096, and DO-0390 list all functional areas . Go to </strong><strong>AO-2020.docx (explain). Then go to Data Reference file</strong><strong>&gt;A0-2020-OMA-FA.PDF (research).</strong></p>
      <p><strong>Question</strong>: What is the Functional Area for Physical Security Matters that Beginning Fiscal Year (BGFY) 2010 and the Termination Fiscal Year (TMFY) is still open? <strong>131034QPSM</strong></p>
      <p><strong>Instructor/Students: Go to 37-100&gt;2C-MDEP1&gt;page 2C-MDEP1-19</strong></p>
      <p>Management decision packages (MDEPS) account for army resources.&nbsp; MDEPS describe the capability of the total army; active, guard, and reserve.&nbsp; Individually an MDEP describes a particular organization, program, or function and records the resources associated with the intended output.&nbsp; An individual MDEP applies uniquely to one of the following six management areas:</p>
      <p>A.Missions of modified tables of organization and equipment (MTOE) units.</p>
      <p>B.Missions of table of distribution and allowance (TDA) units and army wide standard functions.</p>
      <p>C.Missions of standard installation organizations (SIOS).</p>
      <p>D.Acquisition, fielding, and sustainment of weapon and information systems.</p>
      <p>E.Special visibility programs (SVPS).</p>
      <p>F.Short term projects (STPS).</p>
      <p>During programming, MDEPS provide useful visibility.&nbsp; They assist army managers, decision makers, and leaders to assess program worth, confirm compliance, and rank resource claimants.&nbsp; During budgeting, MDEPS help convey approved programs and priorities into budget estimates.&nbsp; They also assist HQDA program evaluation groups post program changes caused by budget decisions and approved funding.&nbsp; During execution, the posted MDEPS help HQDA principals and commanders of major army commands (MACOMS) and other operating agencies track program and financial performance.</p>
    </div>
  </Card>
</template>

<style scoped>
.ImageWrapper {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
}
.ImageWrapper > figure > img {
  max-width: calc(1871px / 2);
  width: 100%;
  margin-bottom: 20px;
}

.ThreeWrapper {
  width: 100%;
  margin-bottom: 32px;
}

ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding-left: 0;
}

ul > li {
  width: 33%;
  list-style: none;
  margin-bottom: 0;
}

ul > li > b {
  font-weight: 700;
}

</style>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'StatesofanAppropriationExamples',
  
  data() {
    return {
      Image: require('@/assets/Functional_Area.png')
    }
  }
  
}
</script>